var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronSmallRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 8,
  fill: "none",
  viewBox: "0 0 8 8"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  fillRule: "evenodd",
  d: "M1.786 7.854a.5.5 0 0 1 0-.708L4.933 4 1.786.854a.5.5 0 0 1 .708-.708L6.347 4 2.494 7.854a.5.5 0 0 1-.708 0",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h8v8H0z"
})))));
export { SvgChevronSmallRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNzQ0Xzk0MjMpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjc4NjQ2IDcuODUzNTVDMS41OTEyIDcuNjU4MjkgMS41OTEyIDcuMzQxNzEgMS43ODY0NiA3LjE0NjQ1TDQuOTMyOTEgNEwxLjc4NjQ2IDAuODUzNTUzQzEuNTkxMiAwLjY1ODI5MSAxLjU5MTIgMC4zNDE3MDkgMS43ODY0NiAwLjE0NjQ0N0MxLjk4MTcyIC0wLjA0ODgxNTcgMi4yOTgzMSAtMC4wNDg4MTU4IDIuNDkzNTcgMC4xNDY0NDdMNi4zNDcxMiA0TDIuNDkzNTcgNy44NTM1NUMyLjI5ODMxIDguMDQ4ODIgMS45ODE3MiA4LjA0ODgyIDEuNzg2NDYgNy44NTM1NVoiIGZpbGw9IiMxQzFDMUEiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF83NDRfOTQyMyI+CjxyZWN0IHdpZHRoPSI4IiBoZWlnaHQ9IjgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";